
import "./timeago.coffee"
